module.exports = __webpack_public_path__ + "img/pwonder_ua.ff41b0ba.webp";